import React, { useState, useEffect } from 'react'
import { Theme, presetGpnDefault } from '@consta/uikit/Theme';
import { useDispatch } from 'react-redux';
import AppRouter from './components/AppRouter';
import { BrowserRouter } from 'react-router-dom';
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import classes from './App.module.scss'
import './index.css';
import { initializeAuthState } from './store/authSlice';

const App = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const dispatch = useDispatch();

  // Инициализируем состояние из localStorage при загрузке приложения
  useEffect(() => {
    console.log('Инициализация приложения...');
    dispatch(initializeAuthState());
  }, [dispatch]);

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // Отслеживаем изменения пути
  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleLocationChange);
    
    const interval = setInterval(() => {
      if (window.location.pathname !== currentPath) {
        setCurrentPath(window.location.pathname);
      }
    }, 100);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      clearInterval(interval);
    };
  }, [currentPath]);

  // Проверяем, нужно ли показывать layout
  const shouldShowLayout = !currentPath.includes('/platform/login') && 
                          !currentPath.endsWith('/login');

  return (
    <Theme preset={presetGpnDefault}>
      <BrowserRouter basename='/platform/'>
        {shouldShowLayout ? (
          <div className={classes.app}>
            <Header 
              onMenuToggle={handleSidebarToggle}
              isSidebarCollapsed={isSidebarCollapsed}
            />
            <div className={classes.mainContent}>
              <Sidebar 
                isCollapsed={isSidebarCollapsed}
                onToggle={handleSidebarToggle}
              />
              <div className={classes.pageContent}>
                <AppRouter/>
              </div>
            </div>
          </div>
        ) : (
          <AppRouter/>
        )}
      </BrowserRouter>
    </Theme>
  );
}

export default App;